import { AgeRanges } from './age-range';
import { Genders } from './gender';

export const AudienceGroupNegativeReferenceId = -100;

export const initialAudienceGroupData = {
  Id: AudienceGroupNegativeReferenceId,
  Name: '',
  Audiences: [],
  Profiles: [],
  AgeRanges: Object.keys(AgeRanges),
  GenderTypes: Object.keys(Genders),
};
